import router from "@/router/router";

export const useNavigateBack = (fallbackRoute: string, params?: any, query?: any) => {
  if (history.length > 1) {
    router.push({ name: fallbackRoute, params, query });
    return;
  }
  history.back();
};
